import { useState } from 'react'
import { mutations } from '../../resources'
import actions from '../../store/actions'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'
import { User } from '../../resources/auth/types'

export const useDissociateGoogle = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const dissociateGoogle = (): Promise<User> => {
        setInProgress(true)
        return mutations
            .dissociateGoogle()
            .then((response) => {
                dispatch(actions.setUser(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        dissociateGoogle,
        inProgress,
    }
}
